export default __webpack_public_path__ + "static/media/05.4efa3825.jpg";